module.exports = __webpack_public_path__ + "img/icon-popconfirm-check.bc4ec627.svg";